import { render, staticRenderFns } from "./GenericComponentLoader.vue?vue&type=template&id=2b2f1c25&"
import script from "./GenericComponentLoader.vue?vue&type=script&lang=js&"
export * from "./GenericComponentLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports